import React, { useRef, useEffect } from 'react';

const HeadlineBlock = ({ block, isActive, onChange, isRTL = false, language = 'en' }) => {
  const inputRef = useRef(null);
  const { text = '', level = 2 } = block.content || {};

  useEffect(() => {
    if (isActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isActive]);

  const handleChange = (e) => {
    onChange({ text: e.target.value });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const textDirection = isRTL ? 'rtl' : 'ltr';
  const textAlign = isRTL ? 'text-right' : 'text-left';
  const placeholder = level === 2 
    ? (isRTL ? 'כותרת...' : 'Heading...') 
    : (isRTL ? 'כותרת משנה...' : 'Subheading...');

  const baseClasses = `w-full bg-transparent border-none outline-none resize-none font-bold text-gray-900 ${textAlign}`;
  const sizeClasses = level === 2 
    ? 'text-2xl md:text-3xl' 
    : 'text-xl md:text-2xl';

  return (
    <div className="headline-block">
      <input
        ref={inputRef}
        type="text"
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        dir={textDirection}
        className={`${baseClasses} ${sizeClasses}`}
      />
    </div>
  );
};

export default HeadlineBlock;
